import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { CTAButton } from '../ui/CTAButton';
export function ClosingSection() {
  return <section className="py-16 md:py-24 bg-[#166534] text-white px-4 text-center" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <FadeInSection data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-amber-50" data-id="element-33">
            Es Hora de Recuperar Tu Vida
          </h2>

          <div className="space-y-6 text-xl leading-relaxed mb-12 text-green-50" data-id="element-34">
            <p data-id="element-35">
              Imagina despertar mañana sintiéndote verdaderamente descansado.
            </p>
            <p data-id="element-36">
              Imagina pasar por la tarde sin sentir esa necesidad desesperada de
              azúcar.
            </p>
            <p data-id="element-37">
              Imagina tener la energía para jugar con tus hijos, rendir en tu
              trabajo y disfrutar tu día sin sentirte como un esclavo de la
              comida.
            </p>
            <p className="font-bold text-amber-300 text-2xl mt-8" data-id="element-38">
              Esa persona que quieres ser está a solo una decisión de distancia.
            </p>
            <p data-id="element-39">
              No dejes que otro día pase sintiéndote menos de lo que mereces.
            </p>
          </div>

          <CTAButton text="Sí, Quiero Empezar Hoy Mismo" className="bg-amber-500 hover:bg-amber-600 text-green-900" data-id="element-40" />
        </FadeInSection>
      </div>
    </section>;
}